<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17.207" height="12.707" viewBox="0 0 17.207 12.707">
    <g id="Group_4" data-name="Group 4" transform="translate(-0.5 -0.56)">
      <path id="Path_3" data-name="Path 3" d="M0,.5H16.5" transform="translate(0.5 6.5)" fill="none" :stroke="color" stroke-miterlimit="10" stroke-width="1"/>
      <path id="Path_4" data-name="Path 4" d="M0,0,6,6,0,12" transform="translate(11 0.913)" fill="none" :stroke="color" stroke-miterlimit="10" stroke-width="1"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'arrow-icon',
  props: ['color']
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/base/icons/ArrowIcon.vue